import { Link } from '@tanstack/react-router';
import type { LucideIcon } from 'lucide-react';
import { ArrowRight } from 'lucide-react';

export interface JumpLink {
  label: string;
  icon: LucideIcon;
  /** Pre-built URL string from `appUrls.*`. */
  to: string;
}

interface ViewJumpNavProps {
  links: JumpLink[];
}

/**
 * A compact contextual navigation strip for jumping between related views
 * (task detail ↔ inspection report ↔ property monitoring). Renders nothing
 * when the links array is empty.
 */
export function ViewJumpNav({ links }: ViewJumpNavProps) {
  if (!links.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 border-y border-dashed border-border py-2.5">
      <span className="text-[10px] font-semibold uppercase tracking-[0.22em] text-foreground/40">
        Also view
      </span>
      {links.map(({ label, icon: Icon, to }) => (
        <Link
          key={to}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- dynamic app-url string, not a literal route
          to={to as any}
          className="group inline-flex items-center gap-1.5 text-xs font-semibold text-sidebar-primary transition-colors hover:text-sidebar-primary/70"
        >
          <Icon className="size-3.5 shrink-0" />
          {label}
          <ArrowRight className="size-3 -translate-x-1 opacity-0 transition-all group-hover:translate-x-0 group-hover:opacity-100" />
        </Link>
      ))}
    </div>
  );
}
